<template>
	<div class="info-panel column main is-5">
		<div class="panel info-panel">
			<div class="panel-block title">
				{{ fireProtection.name }}
			</div>
			<div class="panel-block block">
				<p class="label">Typ</p>
				<div class="box">{{ fireProtection.inventoryType }}</div>
			</div>
			<div class="panel-block block">
				<p class="label">Rekommendation</p>
				<div class="box">{{ fireProtection.recommendation }}</div>
			</div>
			<div class="panel-block block">
				<p class="label">Instruktion</p>
				<div class="box">{{ fireProtection.instruction }}</div>
			</div>
			<div class="panel-block block">
				<p class="label">Beskrivning</p>
				<div class="box">{{ fireProtection.description }}</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		fireProtection: Object
	}
};
</script>
